import { debounce } from 'lodash';

window.addEventListener("DOMContentLoaded", function (e) {

    function adjustLTOLayout() {
        const LTOLayouts = document.querySelectorAll(".ticket-passes-comparison-list-wrapper.lto-layout");

        LTOLayouts.forEach(function (ltoLayout) {
            const tickets = ltoLayout.querySelectorAll(".ticket-passes-comparison-list__item");

            tickets.forEach(function (ticket) {
                const heightElem = ticket.querySelector('[data-js="lto-content-height"]');
                const sellingPoints = ticket.querySelector(".ticket-passes-comparison-list__item__text__sellingpoints");

                if(heightElem) {
                    const height = heightElem.offsetHeight;
                    sellingPoints.style.marginTop = `${-height}px`;
                }
            });    
        });
    }

    adjustLTOLayout();

    window.addEventListener("resize", debounce(adjustLTOLayout, 250));


    const toggleButtonNodeList = document.querySelectorAll(".ticket-passes-comparison-list__item__sellingpoints-toggle-button-wrapper button");

        toggleButtonNodeList.forEach(function(button) {
            button.addEventListener("click", function () {

                const expandText = button.dataset.expandtext;
                const collapseText = button.dataset.collapsetext;
                const toggleElement = button.parentElement.previousElementSibling;
                const spanElement = button.querySelector("span");

                if (button.classList.contains("active")) {
                    button.classList.remove("active");
                    toggleElement.hidden = true;
                    spanElement.textContent = expandText;
                } else {
                    button.classList.add("active");
                    toggleElement.hidden = false;
                    spanElement.textContent = collapseText;
                }

                try {
                    $.fn.matchHeight._update();
                } catch (error) {
                    console.error(error);
                }
            });

    });

});